import React from 'react';
import { useLocale, setLocale, SUPPORTED_LOCALES, Locale } from '../i18n';
import './LanguageSwitcher.css';

const LABELS: Record<Locale, string> = {
  en: 'EN',
  fr: 'FR',
};

/**
 * Floating language picker (top-right) for the promo pages. Changing the
 * language persists the choice and reloads so all copy re-renders.
 */
const LanguageSwitcher: React.FC = () => {
  const locale = useLocale();

  return (
    <div className="lang-switcher">
      <select
        aria-label="Language"
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l} value={l}>
            {LABELS[l]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
